var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSave = function SvgSave(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7762 3.29243V6.67689C16.7762 7.37843 16.156 7.95783 15.4051 7.95783H9.59388C8.843 7.95783 8.22271 7.37843 8.22271 6.67689V2H5.64359C4.7407 2 4 2.75686 4 3.68181V20.3182C4 21.2421 4.73965 22 5.64359 22H7.28717V14.0159C7.28717 13.1139 8.00541 12.379 8.89811 12.379H16.1019C16.9946 12.379 17.7128 13.1139 17.7128 14.0159V22H19.3564C20.2593 22 21 21.2431 21 20.3182L20.999 8.53723C20.999 7.9474 20.7705 7.368 20.3573 6.95564L16.7762 3.29243Z",
    fill: "#8075E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1019 13.4918H8.89706C8.61447 13.4918 8.37471 13.7256 8.37471 14.0148V21.9989H16.6232V14.0148C16.6242 13.7256 16.3845 13.4918 16.1019 13.4918Z",
    fill: "#8075E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59387 6.84393H15.4051C15.5795 6.84393 15.6876 6.74371 15.6876 6.67689V2.30066C15.3612 2.10022 14.9908 2 14.6103 2H9.31128V6.67689C9.31128 6.74371 9.41942 6.84393 9.59387 6.84393Z",
    fill: "#8075E6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Save.b277f6f4bfd455a30c2171dc5e3e4ebd.svg";